<template>
  <transition :enter-active-class="enter">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  props: {
    manualShow: Boolean,
    enterClass: {
      default: "bounceInUp"
    }
  },
  computed: {
    enter() {
      return "animated " + this.enterClass;
    }
  },
  methods: {
    scrollEvent() {
      let display = this.$el.style.display;
      let visibility = this.$el.style.visibility;
      this.$el.style.display = "block";
      this.$el.style.visibility = "hidden";
      const rect = this.$el.getBoundingClientRect();
      this.$el.style.display = display;
      this.$el.style.visibility = visibility;
      if (window.innerHeight - rect.top > 100) {
        this.$emit("showAnimate","show");
        this.removeEvent();
      }
    },
    addEvent() {
      window.addEventListener("scroll", this.scrollEvent);
    },
    removeEvent() {
      window.removeEventListener("scroll", this.scrollEvent);
    }
  },
  mounted() {
    this.$nextTick(function() {
      if (!this.manualShow) {
        this.scrollEvent();
        this.addEvent();
      }
    });
  },
  destroyed() {
    this.removeEvent();
  }
};
</script>

